import * as React from 'react'
import { IntlProvider } from 'react-intl'
import { Props } from './bookingDetailsState'
import { root } from './bookingDetailsWidgets'

export default (props: Props): JSX.Element => (
  <IntlProvider locale={window.Gites.locale}>
    {root(props).run(_ => null)}
  </IntlProvider>
)
